import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'ru',
  months: [
    'января',
    'февраля',
    'марта',
    'апреля',
    'мая',
    'июня',
    'июля',
    'августа',
    'сентября',
    'октября',
    'ноября',
    'декабря',
  ],
  monthsShort: ['янв', 'февр', 'мар', 'апр', 'мая', 'июн', 'июл', 'авг', 'сент', 'окт', 'нояб', 'дек'],
  weekdays: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
  weekdaysMin: ['В', 'П', 'В', 'С', 'Ч', 'П', 'С'],
  weekdaysShort: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'HH:mm',
    lts: 'HH:mm:ss',
    L: 'DD.MM.YYYY',
    LL: 'D MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D MMMM',
    LLL: 'D MMMM YYYY, HH:mm',
    'LLL-Y': 'D MMMM, HH:mm',
    LLLL: 'dddd, D MMMM YYYY, HH:mm',
    'LLLL-Y': 'dddd D MMMM, HH:mm',
    l: 'DD.MM.YYYY',
    'l-Y': 'DD.MM',
    ll: 'D MMM YYYY',
    'll-Y': 'D MMM',
    'll-D': 'MMM YYYY',
    lll: 'D MMM YYYY, HH:mm',
    'lll-Y': 'D MMM, HH:mm',
    llll: 'ddd, D MMM YYYY, HH:mm',
    'llll-Y': 'ddd, D MMM, HH:mm',
    'll-Y+w': 'ddd, D MMM',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': 'D MMMM YYYY, HH:mm ([GMT]Z)',
  },
  meridiem: { am: 'AM', pm: 'PM', AM: 'AM', PM: 'PM' },
  past: {
    y: { one: '%s г. назад', few: '%s г. назад', many: '%s л. назад', other: '%s г. назад' },
    M: { one: '%s мес. назад', few: '%s мес. назад', many: '%s мес. назад', other: '%s мес. назад' },
    w: { one: '%s нед. назад', few: '%s нед. назад', many: '%s нед. назад', other: '%s нед. назад' },
    d: { one: '%s дн. назад', few: '%s дн. назад', many: '%s дн. назад', other: '%s дн. назад' },
    h: { one: '%s ч назад', few: '%s ч назад', many: '%s ч назад', other: '%s ч назад' },
    m: { one: '%s мин. назад', few: '%s мин. назад', many: '%s мин. назад', other: '%s мин. назад' },
    s: { one: '%s сек. назад', few: '%s сек. назад', many: '%s сек. назад', other: '%s сек. назад' },
  },
  future: {
    y: { one: 'через %s г.', few: 'через %s г.', many: 'через %s л.', other: 'через %s г.' },
    M: { one: 'через %s мес.', few: 'через %s мес.', many: 'через %s мес.', other: 'через %s мес.' },
    w: { one: 'через %s нед.', few: 'через %s нед.', many: 'через %s нед.', other: 'через %s нед.' },
    d: { one: 'через %s дн.', few: 'через %s дн.', many: 'через %s дн.', other: 'через %s дн.' },
    h: { one: 'через %s ч', few: 'через %s ч', many: 'через %s ч', other: 'через %s ч' },
    m: { one: 'через %s мин.', few: 'через %s мин.', many: 'через %s мин.', other: 'через %s мин.' },
    s: { one: 'через %s сек.', few: 'через %s сек.', many: 'через %s сек.', other: 'через %s сек.' },
  },
  pastLong: {
    y: { one: '%s год назад', few: '%s года назад', many: '%s лет назад', other: '%s года назад' },
    M: { one: '%s месяц назад', few: '%s месяца назад', many: '%s месяцев назад', other: '%s месяца назад' },
    w: { one: '%s неделю назад', few: '%s недели назад', many: '%s недель назад', other: '%s недели назад' },
    d: { one: '%s день назад', few: '%s дня назад', many: '%s дней назад', other: '%s дня назад' },
    h: { one: '%s час назад', few: '%s часа назад', many: '%s часов назад', other: '%s часа назад' },
    m: { one: '%s минуту назад', few: '%s минуты назад', many: '%s минут назад', other: '%s минуты назад' },
    s: { one: '%s секунду назад', few: '%s секунды назад', many: '%s секунд назад', other: '%s секунды назад' },
  },
  futureLong: {
    y: { one: 'через %s год', few: 'через %s года', many: 'через %s лет', other: 'через %s года' },
    M: { one: 'через %s месяц', few: 'через %s месяца', many: 'через %s месяцев', other: 'через %s месяца' },
    w: { one: 'через %s неделю', few: 'через %s недели', many: 'через %s недель', other: 'через %s недели' },
    d: { one: 'через %s день', few: 'через %s дня', many: 'через %s дней', other: 'через %s дня' },
    h: { one: 'через %s час', few: 'через %s часа', many: 'через %s часов', other: 'через %s часа' },
    m: { one: 'через %s минуту', few: 'через %s минуты', many: 'через %s минут', other: 'через %s минуты' },
    s: { one: 'через %s секунду', few: 'через %s секунды', many: 'через %s секунд', other: 'через %s секунды' },
  },
  abbr: {
    y: { one: '%s г', few: '%s г', many: '%s лет', other: '%s г' },
    M: { one: '%s мес', few: '%s мес', many: '%s мес', other: '%s мес' },
    w: { one: '%s нед', few: '%s нед', many: '%s нед', other: '%s нед' },
    d: { one: '%s дн', few: '%s дн', many: '%s дн', other: '%s дн' },
    h: { one: '%s ч', few: '%s ч', many: '%s ч', other: '%s ч' },
    m: { one: '%s мин', few: '%s мин', many: '%s мин', other: '%s мин' },
    s: { one: '%s с', few: '%s с', many: '%s с', other: '%s с' },
  },
  full: {
    y: { one: '%s год', few: '%s года', many: '%s лет', other: '%s года' },
    M: { one: '%s месяц', few: '%s месяца', many: '%s месяцев', other: '%s месяца' },
    w: { one: '%s неделя', few: '%s недели', many: '%s недель', other: '%s недели' },
    d: { one: '%s день', few: '%s дня', many: '%s дней', other: '%s дня' },
    h: { one: '%s час', few: '%s часа', many: '%s часов', other: '%s часа' },
    m: { one: '%s минута', few: '%s минуты', many: '%s минут', other: '%s минуты' },
    s: { one: '%s секунда', few: '%s секунды', many: '%s секунд', other: '%s секунды' },
  },
  justNow: 'Только что',
  yesterday: 'Вчера',
  today: 'Сегодня',
  tomorrow: 'Завтра',
  weekStart: 1,
  timeRange: '%$1s – %$2s',
  timeZone: '%$1s %$2s',
  timePref: {},
  timeRangeStyles: {
    yl: { start: 'D MMMM YYYY', end: 'D MMMM YYYY' },
    'yl-1': { start: 'D MMMM', end: 'D MMMM YYYY' },
    ml: { start: 'D MMMM', end: 'D MMMM' },
    'ml-1': { start: 'D', end: 'D MMMM YYYY' },
    dl: { start: 'D', end: 'D MMMM' },
    y: { start: 'D MMM YYYY', end: 'D MMM YYYY' },
    'y-1': { start: 'D MMM', end: 'D MMM YYYY' },
    m: { start: 'D MMM', end: 'D MMM' },
    'm-1': { start: 'D', end: 'D MMM YYYY' },
    d: { start: 'D', end: 'D MMM' },
    Y: { start: 'ddd, D MMM YYYY', end: 'ddd, D MMM YYYY' },
    'Y-1': { start: 'ddd, D MMM', end: 'ddd, D MMM YYYY' },
    M: { start: 'ddd, D MMM', end: 'ddd, D MMM' },
    D: { start: 'ddd, D MMM', end: 'ddd, D MMM' },
    yt: { start: 'D MMM YYYY, HH:mm', end: 'D MMM YYYY, HH:mm' },
    mt: { start: 'D MMM, HH:mm', end: 'D MMM, HH:mm' },
    dt: { start: 'D MMM, HH:mm', end: 'D MMM, HH:mm' },
    t: { start: 'HH:mm', end: 'HH:mm' },
    'yt+to': { start: 'D MMM YYYY, HH:mm', end: 'D MMM YYYY, HH:mm ([GMT]Z)' },
    'mt+to': { start: 'D MMM, HH:mm', end: 'D MMM, HH:mm ([GMT]Z)' },
    'dt+to': { start: 'D MMM, HH:mm', end: 'D MMM, HH:mm ([GMT]Z)' },
    't+to': { start: 'HH:mm', end: 'HH:mm ([GMT]Z)' },
  },
};
const localeName: LocaleName = 'ru';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  ordinal: (n) => `${n}`,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'AM' : 'AM';
    } else {
      return isLowerCase ? 'PM' : 'PM';
    }
  },
};
